export default __webpack_public_path__ + "static/media/greet.5e4c71df.jpg";